import { v4 as uuidv4 } from "uuid"
import { getFlagValue } from "app/assets/javascripts/utils/ab_tests"
import { addEventToQueue } from "./event-tracker"
import { getPageKey, getSlideshowId } from "./base-tracker"
import { isMobile } from "../utils/breakpoints"

const VIEW_THRESHOLD = 0.5 // The recommendation must be 50% in view before it is tracked

const store = {
  trackedRecs: {},
  viewId: uuidv4(),
  modules: {},
}

const markAsTracked = (id) => {
  store.trackedRecs[id] = true
}

const buildTrackingEvent = (recommendationElement, eventType) => {
  const { index, sourceName, recId, score, moduleId } = recommendationElement.dataset
  const { section, modulePosition, moduleType } = store.modules[moduleId]

  return {
    eventName: "rec_event_stream",
    eventBody: {
      event: eventType,
      index,
      rec_id: recId,
      view_id: store.viewId,
      slideshow_id: getSlideshowId(),
      source: sourceName,
      score,
      section,
      module_position: modulePosition,
      page: getPageKey(),
      module_type: moduleType,
      time_stamp: Date.now(),
      platform: isMobile() ? "mobile_web" : "desktop_web",
    },
  }
}

const onRecommendationClick = (e) => {
  const element = e.currentTarget
  const trackingEvent = buildTrackingEvent(element, "rc")
  addEventToQueue(trackingEvent)
}

const onRecommendationIntersectionChange = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const recommendationElement = entry.target
      const trackingId = recommendationElement.dataset.recId

      if (!store.trackedRecs[trackingId]) {
        const trackingEvent = buildTrackingEvent(recommendationElement, "rv")
        markAsTracked(trackingId)
        addEventToQueue(trackingEvent)
      }
    }
  })
}

const trackRecommendations = () => {
  const observer = new IntersectionObserver(onRecommendationIntersectionChange, {
    root: null, // Track intersection with entire viewport
    threshold: VIEW_THRESHOLD,
  })

  const recommendationNodeList = document.querySelectorAll(".recommendation")

  for (let recommendation of recommendationNodeList) {
    observer.observe(recommendation)
    recommendation.addEventListener("click", onRecommendationClick.bind(recommendation))
  }
}

const storeModuleInfo = (recommendationModule) => {
  const { section, moduleId, moduleType } = recommendationModule.dataset

  // For situations when two modules have the same module ID
  // e.g. right rail on mobile and right rail on desktop
  if (store.modules[moduleId]) {
    return
  }

  if (store.modules[section] >= 0) {
    store.modules[section] = store.modules[section] + 1
  } else {
    store.modules[section] = 0
  }

  store.modules[moduleId] = {
    section,
    modulePosition: store.modules[section],
    moduleType: moduleType,
  }
}

const detectModuleTypes = () => {
  const modules = document.querySelectorAll(".recommendation-module")

  for (let recommendationModule of modules) {
    storeModuleInfo(recommendationModule)
  }
}

const initializeTracking = async () => {
  const isFeatureFlagActive = await getFlagValue("recommendation_impression_tracking")
  if (isFeatureFlagActive) {
    detectModuleTypes()
    trackRecommendations()
  }
}

initializeTracking()
